import {Suspense, useEffect, useRef} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit, useAuth} from './modules/auth'
import {ThemeModeProvider} from '../_metronic/partials'

const App = () => {
  // const lastInteractionRef = useRef<number>(Date.now())
  const {logout} = useAuth()
  const location = useLocation()

  // useEffect(() => {
  //   const handleInteraction = () => {
  //     lastInteractionRef.current = Date.now()
  //   }

  //   const checkInactive = () => {
  //     const currentTime = Date.now()
  //     const timeSinceLastInteraction = currentTime - lastInteractionRef.current

  //     if (timeSinceLastInteraction >= 30 * 60 * 1000 && location.pathname !== '/auth') {
  //       logout()
  //       // Function to execute after 30 minutes of inactivity, except when on "/auth" path
  //     }
  //   }

  //   document.addEventListener('mousemove', handleInteraction)
  //   document.addEventListener('keydown', handleInteraction)

  //   const checkInactiveTimer = setInterval(checkInactive, 1000) // Check every second

  //   return () => {
  //     document.removeEventListener('mousemove', handleInteraction)
  //     document.removeEventListener('keydown', handleInteraction)
  //     clearInterval(checkInactiveTimer)
  //   }
  //   // eslint-disable-next-line
  // }, [location])

  useEffect(() => {
    const handler = (e: WheelEvent) => {
      const target = e.target as HTMLElement
      if (target?.tagName === 'INPUT' && target.getAttribute('type') === 'number') {
        e.preventDefault()
      }
    }

    document.addEventListener('wheel', handler, {passive: false})

    return () => {
      document.removeEventListener('wheel', handler)
    }
  }, [])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <LayoutProvider>
        <ThemeModeProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </ThemeModeProvider>
      </LayoutProvider>
    </Suspense>
  )
}

export {App}
